import * as React from "react";

export function understandChildren(childrenNode: any, renderContent?: any, renderTarget?: any) {
    let children = React.Children.toArray(childrenNode) as React.ReactElement<any>[];

    // webpack removes this check in production mode
    if (process.env.NODE_ENV !== "production") {
        if (!renderContent && !renderTarget && children.length !== 2) {
            throw new Error("Popover expects two children (first one as target and second one as popup content)");
        }
        if (renderContent && !renderTarget && children.length !== 1) {
            throw new Error("Popover with renderContent prop expects one child as target");
        }
        if (!renderContent && renderTarget && children.length !== 1) {
            throw new Error("Popover with renderTarget prop expects one child as content");
        }
    }

    const [firstChild, secondChild] = children;

    return {
        content: renderTarget ? firstChild : secondChild,
        target: renderTarget ? null : firstChild,
    };
}
